// extracted by mini-css-extract-plugin
module.exports = {"row":"CartAsideTop_row__cQ_cN","back":"CartAsideTop_back__gQJQF","text":"CartAsideTop_text__a0G1R","count":"CartAsideTop_count__pIQQi"};